import request from "superagent";

import { getAuthHeader } from "./superagent";

export const HttpMethod = {
  GET: "GET",
  PUT: "PUT",
  POST: "POST",
  PATCH: "PATCH",
  DELETE: "DELETE",
};

// @ts-expect-error TODO(typecheck-unify): TS7031 Binding element 'method' implicitly has an 'any' type.
export async function callApi({ method, url, body = {}, query = {}, headers = {} }) {
  const authHeader = await getAuthHeader();

  const res = await request(method, url)
    .set({ ...authHeader, ...headers })
    .send(body)
    .query(query);
  return res.body;
}
